import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';
import { FavouriteAuctions } from '../interfaces/store/FavouriteAuctions';

const root = createSelector<ReduxStore, ReduxStore, ReduxStore>(
  root => root,
  root => root
);

export const favouriteAuctions = createSelector<
  ReduxStore,
  ReduxStore,
  FavouriteAuctions
>(root, root => root?.favouriteAuctions ?? []);

export const mySavedAuctions = createSelector(
  root,
  root => root?.mySavedAuctions?.auctions ?? []
);

export const mySavedAuctionsLoading = createSelector(
  root,
  root => root?.mySavedAuctions?.loading
);

export const savedAuctions = createSelector(
  root,
  root => root?.myAuctions ?? []
);

export const timeDiff = createSelector(
  root,
  root => root?.time?.serverOffset ?? 0
);

export const serverRenderedAt = createSelector(
  root,
  root => root?.time?.renderedAt ?? null
);

export const app = createSelector(root, root => root?.app ?? {});

export const appIsLoading = createSelector(
  app,
  root => root?.isLoading ?? false
);

export const messagesBottom = createSelector(
  root,
  root => root?.messages?.bottom
);

export const messagesTop = createSelector(root, root => root.messages.top);

export const isContactButtonHidden = createSelector(
  root,
  root => root?.contactButton?.isHidden ?? false
);

export const isDefaultTriggerEnabledSelector = createSelector(
  root,
  root => root?.contactButton?.isDefaultTriggerEnabled ?? true
);

export const contactButtonPositionSelector = createSelector(
  root,
  root => root?.contactButton?.position ?? {}
);

export const hasFavouriteAuctions = createSelector(
  favouriteAuctions,
  root => Boolean(root?.length) ?? false
);

export const hasSavedAuctions = createSelector(
  savedAuctions,
  root => Boolean(root?.length) ?? false
);

export const isFooterHiddenSelector = createSelector(
  root,
  root => root?.app.isFooterHidden ?? false
);
